import { useState, useEffect } from 'react';
import { useOs } from '@mantine/hooks';

export default function usePwaPrompt() {
  const [promptState, setPromptState] = useState({
    show: false,
    platform: null,
  });
  const os = useOs();

  useEffect(() => {
    const isDesktop = ['windows', 'macos', 'linux'].includes(os);
    const isIos = os === 'ios';

    if (!isIos && !isDesktop) return;

    const isStandalone = () => {
      return (
        ('standalone' in window.navigator && window.navigator.standalone) ||
        window.matchMedia('(display-mode: standalone)').matches
      );
    };

    const shouldShowPrompt = () => {
      const expiryString = localStorage.getItem('pwaPromptExpiry');

      if (!expiryString) return true;

      const expiryDate = parseInt(expiryString, 10);
      const now = new Date().getTime();

      if (now > expiryDate) {
        localStorage.removeItem('pwaPromptExpiry');
        return true;
      }

      return false;
    };

    if (!isStandalone() && shouldShowPrompt()) {
      const platform = isIos ? 'ios' : 'desktop';
      const timer = setTimeout(
        () => setPromptState({ show: true, platform }),
        2500,
      );
      return () => clearTimeout(timer);
    }
  }, [os]);

  const dismissPrompt = () => {
    setPromptState((prev) => ({ ...prev, show: false }));

    const THREE_DAYS_IN_MS = 3 * 24 * 60 * 60 * 1000;
    const expiryDate = new Date().getTime() + THREE_DAYS_IN_MS;

    localStorage.setItem('pwaPromptExpiry', expiryDate.toString());
  };

  return {
    showPrompt: promptState.show,
    platform: promptState.platform,
    dismissPrompt,
  };
}
